<template>
    <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem :list="list" :to="to">{{list}}</BreadcrumbItem>
    </Breadcrumb>
</template>
<script>
export default {
  name: 'SecNav',
  props: {
    list: {
      type: String,
      default() {
        return ''
      }
    },
    to: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>
<style scoped>
  .ivu-breadcrumb {
    background: #FFF;
    padding: 5px 0px 0px 10px;
  }
</style>

